import s from './index.module.css'
import style from '../../index.module.css'
import commonStyle from '../Common/common.module.css'
import UploadFile from '../../../../../UI/UploadFile'
import { useEffect, useRef, useState } from 'react'
import { ButtonAdd, ButtonRemove } from '../Common/Buttons'
import { useInputNew } from '../../../../../UI/InputNew/useInputNew'
import { InputNew, InputSelect, InputFormate } from '../../../../../UI/InputNew'
import classNames from 'classnames'
import { customAlphabet } from 'nanoid'
import { jsonConvert } from '@/helpers/jsonConvert'
import { isJson } from '@/helpers/isJson'

export const Basket = ({ data, edit }) => {
const first = useRef(true)

useEffect(()=>{
  if(first.current && !!data?.answer_options?.length){
    edit(prev => {
      return { 
                ...prev, 
                'answer_options': !!prev?.answer_options?.length ? 
                    prev?.answer_options.map((el) => {
                      return {
                                ...el, 
                                id: Number(el.id), 
                                ...(el.basket_id && {
                                  basket_id: Number(el.basket_id)
                                }), 
                                text: isJson(el.text) ? jsonConvert(el.text) : el.text
                             }
                    }) : []
             };
    })
    first.current = false;
  }
 
}, [data?.answer_options?.length])

  // Создаем функцию для генерации строк только из цифр
const generateUniqueNumberString = customAlphabet('0123456789', 10);

const nanoIdModified = () => {
  // Генерируем строку и преобразуем её в число
  return parseInt(generateUniqueNumberString(), 10);
};
  
  const addBasket = () => {
    edit(prev => {
      return { 
                ...prev, 
                'baskets': !!prev?.baskets?.length ? [...prev?.baskets, {id: nanoIdModified(), name: ''}] : [{id: nanoIdModified(), name: ''}]
             };
    })
  }
  const addAnswerOption = (type) => {
    edit(prev => {
      return { 
                ...prev, 
                'answer_options': [...prev.answer_options, {type, id: nanoIdModified(), [type]: ''}]
             };
    })
  }
  const removeBasket = (basketId) => {
    edit(prev => {
      const new_correct_answer = {
        ...prev.correct_answer
      }
      delete new_correct_answer[basketId];
      return { 
                ...prev, 
                'baskets': prev?.baskets?.filter((basket) => basket.id !== basketId),
                correct_answer: new_correct_answer
             };
    })
  }

  const removeAnswerOption = (answerOptionId, basketId) => {
    edit(prev => {
      const new_correct_answer = {
        ...prev.correct_answer,
        ...(( prev.correct_answer && (basketId in prev.correct_answer)) ? {[basketId]: prev.correct_answer[basketId]?.filter((el) => el !== answerOptionId)} : {}),
      };

      return { 
                ...prev, 
                'answer_options': prev?.answer_options?.filter((answerOption) => answerOption.id !== answerOptionId),
                correct_answer: new_correct_answer
             };
    })
  }

  const changeBasketName = (basketId, name) => {
    edit(prev => {
      return  { 
                ...prev, 
                'baskets': prev?.baskets.map((basket) => {

                  if(basket.id === basketId){
                    return {
                      ...basket,
                      name
                    }
                  }

                  return basket;
                  
                })
              };
    })
  }

  return <div className={s.wrapper}>
    <span className={style.heading}>Названия корзин:</span>
    <div className={s.list}>
      {
        data?.baskets?.map((basket) => {
          return (
            <div className={s.basket}>
              <InputNew
              classNameForBox={commonStyle.inputBox}
              className={style.inputNew} 
              
              value={basket.name}
              onChange={(e) => {
                changeBasketName(basket.id, e.target.value)
              }}

              placeholder={'Введите название'} />
              <ButtonRemove onClick={() => removeBasket(basket.id) } />
            </div>
          )
        })
      }
        
      <ButtonAdd onClick={addBasket} />
    </div>

    <div className={s.scheme}>
      <span className={classNames(style.heading, s.heading)}>Заполните схему</span>
        {
          data.answer_options?.map((answerOption) => {
            console.log(answerOption)
            console.log(answerOption.basket_id)
            return (
              <div className={s.schemeItem}>
                {
                  answerOption.type === 'img' && <div className={s.fileWrapper}>
                    <UploadFile
                        className={classNames(commonStyle.file, s.file)} 
                        value={answerOption.img} 
                        title={answerOption.img ? answerOption.img : 'Загрузите файл'}
                        onChange={val => { 
                          edit(prev => {
                            return { 
                                      ...prev, 
                                      answer_options: prev.answer_options.map((el) => {
                                        if(el.id === answerOption.id){
                                          return {
                                            ...el,
                                            img: val
                                          }
                                        }
                                        return el;
                                      })
                                   };
                          })
                          }
                        }
                        accept={"image/*"}
                    />
                  </div>
                }
                {
                  answerOption.type === 'text' && <div className={s.fileWrapper}>
                    <InputFormate
                      tiptapClassContent={commonStyle.tiptapClassContent}
                      tiptapClassContentProseMirror={commonStyle.tiptapClassContentProseMirror}
                      className={classNames(style.inputNew, commonStyle.inputFormate)} 
                      placeholder={'Заполните вариант'} 
                      
                      value={answerOption.text}
                      onChange={(e) => {
                        edit(prev => {
                          return { 
                                    ...prev, 
                                    answer_options: prev.answer_options.map((el) => {
                                      if(el.id === answerOption.id){
                                        return {
                                          ...el,
                                          text: e.target.value
                                        }
                                      }
                                      return el;
                                    })
                                 };
                        })
                      }} 
                    />
                  </div>
                }
                
                <div className={s.selectWrapper}>
                  <InputSelect 
                      classNameInputBoxSelect={commonStyle.inputBoxSelect} 
                      className={classNames(style.inputNew, s.select)} 
                      value={answerOption.basket_id ? answerOption.basket_id : null}
                      options={data?.baskets?.map((basket) => ({label: basket.name, value: basket.id})) ?? [] }
                      onChange={(e) => {
                        edit(prev => {
                          const new_correct_answer = {};
                          if(typeof prev?.correct_answer === 'object'){
                            Object.keys(prev?.correct_answer).forEach(key => {
                              new_correct_answer[key]= prev?.correct_answer[key].filter((el) => el != answerOption.id)
                            });
                          }
                          

                          return { 
                                    ...prev, 
                                    answer_options: prev.answer_options.map((el) => {
                                      if(el.id === answerOption.id){
                                        return {
                                          ...el,
                                          basket_id: e.target.value
                                        }
                                      }
                                      return el;
                                    }),
                                    correct_answer: {
                                      ...new_correct_answer,
                                      [e.target.value]: Array.isArray(new_correct_answer[e.target.value]) ? 
                                          [...new_correct_answer[e.target.value], answerOption.id] : 
                                          [answerOption.id]
                                    }
                                 };
                        })
                      }}
                      placeholder='Выберите корзину' />
                </div>
                <ButtonRemove onClick={() => removeAnswerOption(answerOption.id, answerOption.basket_id ?? null)} />
              </div>
            )
          })
        }

        <div className={s.addAnswerOptionWrapper}>
          <div className={s.addAnswerOption} onClick={()=> addAnswerOption('text')}>
            <ButtonAdd />
            <span>Текст</span>
          </div>
          <div className={s.addAnswerOption} onClick={()=> addAnswerOption('img')}>
            <ButtonAdd />
            <span>Изображение</span>
          </div>
        </div>

    </div>

  </div>
}